const TOP5_CONTRACT_ADDRESS_POLYGON = "0x5D21526D4Ea0e992085D6BF128891014799A5151"
const TOP5_CONTRACT_ADDRESS_CRONOS = "0xb94071d5AFD1235Bd5227ce2551fb2A809b87218"
const TOP5_CONTRACT_ADDRESS_GNOSIS_CHAIN = "0xCD2f1a078007BE184e38D8E33d95411D1f9Fb48B"
const BEST5_CONTRACT_ADDRESS = "0xa22190D5aaEb41c489CFf184d535a8Cb7A5d2d26"


export {
    TOP5_CONTRACT_ADDRESS_POLYGON,
    TOP5_CONTRACT_ADDRESS_CRONOS,
    TOP5_CONTRACT_ADDRESS_GNOSIS_CHAIN,
    BEST5_CONTRACT_ADDRESS
}